// MUI color helpers (alpha, getContrastText) throw on anything they cannot parse,
// and colors coming from the API are unvalidated
const HEX_COLOR = /^#([\da-f]{3}|[\da-f]{6})$/i

export const isUsableColor = (color: string | undefined): color is string => !!color && HEX_COLOR.test(color)

// the backend sends the hex both with and without the leading "#"
export const normalizeHexColor = (color: string | undefined): string | undefined => {
    const trimmed = color?.trim()
    if (!trimmed) {
        return undefined
    }

    return trimmed.startsWith("#") ? trimmed : `#${trimmed}`
}
